import { controllerDefinitionBuilder } from '@app/components/Form/helpers';
import { StringRulesBuilder, MixedRulesBuilder } from '@utilities/json-driven-validator/pre-built-contrains';

export default controllerDefinitionBuilder()
  .addControllerConfig({
    label: '',
    type: 'text',
    name: 'fiscalId',
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    defaultValue: undefined,
    placeholder: 'IdOrPasswordFieldPlaceholder',
    validationRules: StringRulesBuilder.new().required('IdOrPasswordFieldIsRequired').get(),
  })
  .addControllerConfig({
    label: '',
    type: 'text',
    name: 'email',
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    defaultValue: undefined,
    placeholder: 'EmailFieldPlaceholder',
    validationRules: StringRulesBuilder.new().required('EmailFieldIsRequired').email('EmailFieldIsInvalid').get(),
  })
  .addControllerConfig({
    label: '',
    placeholder: '',
    type: 'recaptcha',
    name: 'captchaToken',
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    defaultValue: undefined,
    validationRules: StringRulesBuilder.new().required('PasswordFieldIsRequired').get(),
  })
  .addControllerConfig({
    label: '',
    placeholder: '',
    defaultValue: false,
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    name: 'acceptTermsConditions',
    type: 'accept-terms-conditions',
    validationRules: MixedRulesBuilder.new().notOneOf('PleaseAcceptTermsAndConditions', [false]).get(),
  })
  .get();
